import { render, staticRenderFns } from "./ChartLegendTable.vue?vue&type=template&id=5429df89&scoped=true&"
import script from "./ChartLegendTable.vue?vue&type=script&lang=js&"
export * from "./ChartLegendTable.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegendTable.vue?vue&type=style&index=0&id=5429df89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429df89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VIcon,VSimpleTable,VTooltip})
